import ExportButtonWithLoader from '@creditflowresearch/uilib/ExportButtonWithLoader';
import { useFiltersContext } from '@/creditflowresearch/application/FiltersContext';
import { useInventoryTableContext } from '@/creditflowresearch/application/Bonds/InventoryTableContext';
import { useBwicTableContext } from '@/creditflowresearch/application/Bonds/BwicTableContext';
import { useBondsFiltersContext } from '@/creditflowresearch/application/Bonds/BondsFiltersContext';
import { useExportBondsToExcel } from '@/creditflowresearch/application/Bonds/useExportBondsToExcel';

const ExportToExcelButton = () => {
  const { isFetching, exportToExcel } = useExportBondsToExcel();
  const {
    inventoriesData: { inventories: { totalCount: inventoriesTotalCount } },
  } = useInventoryTableContext();
  const {
    bwicsData: { bwics: { totalCount: bwicsTotalCount } },
  } = useBwicTableContext();
  const { params: { search } } = useFiltersContext();
  const { filtersPayload } = useBondsFiltersContext();

  const isDisabled = !(inventoriesTotalCount || bwicsTotalCount);

  return (
    <ExportButtonWithLoader
      onClick={ () => exportToExcel({ assetClassId: undefined, search, filtersPayload }) }
      isFetching={ isFetching }
      isDisabled={ isDisabled }
      tooltipContent="Export to Excel"
      disabledTooltipContent="Export to Excel not available"
      buttonSize="S"
      dataTest="bondsTileExportExcelButton"
      ariaLabel="Export to Excel"
    />
  );
};

export default ExportToExcelButton;
